import * as types from "../constants/ActionTypes";

export function addChart(args = {}, select = false) {
    return (dispatch, getData)=> {

        dispatch({
            type: types.ADD_CHART,
            args
        });

        if (select) {
            let {charts} = getData();
            dispatch({
                type: types.SELECT_CHART,
                index: charts.length - 1
            });
        }
    };
}

export function deleteChart(index) {
    return {
        type: types.DELETE_CHART,
        index
    };
}

export function editChart(index, args) {
    return {
        type: types.EDIT_CHART,
        index,
        args
    };
}

export function moveChart(index, dir) {
    return {
        type: types.MOVE_CHART,
        index,
        dir
    };
}



// WEBPACK FOOTER //
// ./src/kpi/store/actions/ChartActions.js